<template>
  <div class="collectionDetailGroup"
    :style="pageSetting">
    <button type="button" class="btnClose" @click.stop="close"></button>
    <div class="frame">
      <div
        class="collectionClass"
        :class="{ isUnknown: isUnknownClass }">
        <div
          v-for="classItem in collectionGroupItems"
          :key="classItem.collectionClassId"
          class="classItem">
          <div
            v-if="classItem.collectionClassId !== 'unknown'"
            class="className">
            {{ classItem.collectionClassName[lang] }}
          </div>
          <div class="classSubItems">
            <div
              v-for="subItem in classItem.items"
              :key="subItem.subItemId"
              class="classSubItem"
              :class="{ isSelected: selectedSubItemByClass[classItem.collectionClassId] === subItem.subItemId }"
              @click="selectSubItem(classItem, subItem.subItemId)">
              <div
                :style="{
                  backgroundImage: `url('${subItem.attribute.imageList[0]}')`,
                  ...(selectedSubItemByClass[classItem.collectionClassId] === subItem.subItemId) && { boxShadow: `inset 0 0 0 1px ${getPointColor}`, borderColor: getPointColor }
                }"
                class="thumb">
                <button
                  v-if="subItem.attribute.imageList.length > 1"
                  type="button"
                  class="btnViewmore" @click.stop="setDetailSubItem(subItem)"></button>
              </div>
              <div class="subItemName">{{ subItem.collectionItemName[lang] }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="myCollectionGroupBtns">
        <div class="myCollectionInput">
          <input
            v-model.trim="myCollectionName"
            type="text"
            class="input"
            placeholder="저장할 이름을 입력해주세요."
            @keydown.enter.prevent.stop="addMyCollection" />
          <button
            type="button"
            :disabled="!validateOnSubmit"
            class="addMyCollection"
            :style="{backgroundColor: getPointColor}"
            @click.stop="addMyCollection">
            <img :src="collectionIcon.default" alt="" />
            마이콜렉션 담기
          </button>
        </div>
        <div v-if="selectedTotalPrice" class="totalPrice">
          Price {{ priceFormat(selectedTotalPrice) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

export default {
  name: 'DetailGroup',
  props: [
    'locale',
    'lang',
    'pageId',
    'categoryId',
    'isCollectableUser'
  ],
  components: {
    swiper,
    swiperSlide
  },
  computed: {
    collectionItemId () {
      return this.$store.getters['collection/getDetailGroup']
    },
    getCategoryById () {
      return this.$store.getters['collection/getCategoryById'](this.categoryId)
    },
    isMyCollection () {
      return this.$store.getters['collection/getIsMyCollectionItem'](this.collectionItemId)
    },
    collectionIcon () {
      const setting = this.getCategoryById && this.getCategoryById.categorySetting
      const useCollection = setting && setting.useCollection
      const myCollectionSetting = this.$store.getters['collection/getMyCollectionSetting']
      const scrapIcon = myCollectionSetting && {
        ...myCollectionSetting.scrapIcon,
        size: `${myCollectionSetting.scrapIcon.size}px`
      }
      return useCollection && scrapIcon
    },
    getPointColor () {
      return this.$store.getters['collection/getPointColor']
    },
    collectionSetting () {
      return this.$store.getters['collection/getCollectionSetting']
    },
    pageSetting () {
      const setting = this.collectionSetting
      const itemDetail = this.itemInfo && this.itemInfo.attribute
      return  {
        backgroundColor: setting.backgroundColor,
        color: itemDetail && itemDetail.detailColorActive ? itemDetail.detailTextColor : ''
      }
    },
    itemInfo () {
      const collectionItemId = this.collectionItemId
      return collectionItemId && this.$store.getters['collection/getItemByItemId'](collectionItemId)
    },
    collectionClassByCategoryId () {
      const categoryId = this.categoryId
      return this.$store.getters['collection/collectionClassByCategoryId'](categoryId)
    },
    collectionGroupItems () {
      const classes = this.collectionClassByCategoryId
      const typeSetting = this.itemInfo && this.itemInfo.typeSetting

      if (!typeSetting) {
        return []
      }

      if (!Array.isArray(classes) || classes.length === 0) {
        const items = typeSetting.unknown
        if (!Array.isArray(items) || items.length === 0) {
          return []
        }
        return [
          {
            collectionClassId: 'unknown',
            collectionClassName: {
              [this.lang]: ''
            },
            items
          }
        ]
      }

      return classes.reduce((result, item) => {
        const items = typeSetting[item.collectionClassId]

        if (!Array.isArray(items) || items.length === 0) {
          return result
        }
        result.push({
          ...item,
          items
        })
        return result
      }, [])
    },
    isUnknownClass () {
      return this.collectionGroupItems.length === 1 &&
        this.collectionGroupItems[0].collectionClassId === 'unknown'
    },
    selectedTotalPrice () {
      return this.collectionGroupItems.reduce((total, classItem) => {
        const selectedSubItemId = this.selectedSubItemByClass[classItem.collectionClassId]

        const selectedItem = classItem.items.find(subItem => {
          return subItem.subItemId === selectedSubItemId
        })

        return total + Number(selectedItem && selectedItem.price || 0)
      }, 0)
    },
    validateOnSubmit() {
      if (!this.myCollectionName.trim()) {
        return false
      }

      const hasRequired = this.collectionGroupItems
        .filter(classItem => classItem.isRequired)
        .every(classItem => {
          return !!this.selectedSubItemByClass[classItem.collectionClassId]
        })

      if (!hasRequired) {
        return false
      }

      return Object.values(this.selectedSubItemByClass).some(Boolean)
    }
  },
  watch: {
    itemInfo: {
      immediate: true,
      handler(item) {
        if (!item || this.myCollectionName) {
          return
        }
        this.myCollectionName = item.collectionItemName[this.lang]
      }
    },
    collectionGroupItems: {
      immediate: true,
      handler(items) {
        items.forEach(classItem => {
          const firstItem = classItem.items && classItem.items[0]

          if (
            classItem.isRequired &&
            firstItem &&
            !(classItem.collectionClassId in this.selectedSubItemByClass)
          ) {
            this.$set(
              this.selectedSubItemByClass,
              classItem.collectionClassId,
              firstItem.subItemId
            )
          }
        })
      }
    }
  },
  mounted () {
  },
  data() {
    return {
      selectedSubItemByClass: {},
      myCollectionName: '',
      isSubmitting: false
    }
  },
  methods: {
    priceFormat (price) {
      return this.$store.getters['util/getPriceFormatter'](price)
    },
    selectSubItem(classItem, subItemId) {
      const classId = classItem.collectionClassId
      const current = this.selectedSubItemByClass[classId]

      if (classItem.isRequired && current === subItemId) {
        return
      }

      this.$set(
        this.selectedSubItemByClass,
        classId,
        current === subItemId ? null : subItemId
      )
    },
    getSubmitItems () {
      return this.collectionGroupItems
        .filter(classItem => {
          return !!this.selectedSubItemByClass[classItem.collectionClassId]
        })
        .map(classItem => {
          const collectionClassId = classItem.collectionClassId
          const subItemId = this.selectedSubItemByClass[collectionClassId]

          return {
            collectionClassId,
            subItemIds: [subItemId]
          }
        })
    },
    setDetailSubItem (subItem) {
      this.$store.commit('collection/setDetailSubItemGallery', {
        subItemId: subItem.subItemId,
        imageList: subItem.attribute.imageList
      })
    },
    close () {
      this.$store.commit('collection/setDetailGroup', null)
    },
    async addMyCollection () {
      if (this.isSubmitting || !this.validateOnSubmit) {
        return
      }

      this.isSubmitting = true
      this.$store.commit('loading', true)

      const data = {
        pageId: this.pageId,
        collectionCategory: this.itemInfo.collectionCategoryId,
        collectionItemId: this.collectionItemId,
        categoryId: this.categoryId,
        myCollectionName: this.myCollectionName.trim(),
        subItems: this.getSubmitItems()
      }

      try {
        const res = await this.$store.dispatch(
          'collection/addCollection',
          data
        )

        if (!(res && res.result && res.result.orderUUID)) {
          throw new Error('내 콜렉션 저장에 실패했습니다.')
        }

        this.$store.commit(
          'collection/setToastMessage',
          '내 콜렉션에 추가되었습니다.'
        )

        await this.$store.dispatch(
          'collection/getMyCollectionItems',
          {
            pageId: this.pageId
          }
        )

        this.close()
      } catch (error) {
        console.error(error)
        alert(error.message || '내 콜렉션 저장 중 오류가 발생했습니다.')
      } finally {
        this.isSubmitting = false
        this.$store.commit('loading', false)
      }
    }
  }
}
</script>
